export const OrderPaymentStatus = {
  Unpaid: 0,
  Paid: 1,
};
